import React from "react";

const VARIANT_CLASS = {
  primary: "btn--primary",
  secondary: "btn--secondary",
  solid: "btn--solid",
};

const SIZE_CLASS = {
  sm: "btn--sm",
  md: "",
  lg: "btn--lg",
};

/**
 * Reusable CTA button.
 * @param {"primary"|"secondary"|"solid"} [variant="primary"]
 * @param {"sm"|"md"|"lg"} [size="md"]
 * @param {"button"|"a"|"submit"} [as="button"]
 */
const Button = ({
  children,
  variant = "primary",
  size = "md",
  as = "button",
  href,
  className = "",
  icon,
  type = "button",
  onClick,
  ...rest
}) => {
  const classes = ["btn", VARIANT_CLASS[variant], SIZE_CLASS[size], className]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      <span>{children}</span>
      {icon ? <span className="btn__icon" aria-hidden="true">{icon}</span> : null}
    </>
  );

  if (as === "a" || href) {
    return (
      <a className={classes} href={href || "#"} onClick={onClick} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button className={classes} type={type} onClick={onClick} {...rest}>
      {content}
    </button>
  );
};

export default Button;
